/**
 * Интерактив блока «Калькулятор микрокредита»:
 *  - подстановка точного времени в заголовок ({time});
 *  - пересчёт суммы, «Вы вернёте» и текста кнопки по слайдеру.
 *
 * Один и тот же блок используется на странице статьи и на архиве блога
 * (в «широком» варианте .article-calc--wide), поэтому логика вынесена
 * в отдельный компонент и работает со всеми .article-calc на странице.
 */

const formatAmount = (value) =>
	String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

function initCalcTime() {
	const pad = (n) => String(n).padStart(2, "0");

	document.querySelectorAll(".article-calc__time").forEach((el) => {
		const offset = parseInt(el.dataset.offsetMin, 10) || 0;
		const date = new Date(Date.now() + offset * 60000);
		el.textContent = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
	});
}

function initCalculator() {
	const calcs = document.querySelectorAll(".article-calc");

	calcs.forEach((calc) => {
		const slider = calc.querySelector(".article-calc__slider");
		const amountEl = calc.querySelector(".article-calc__amount");
		const returnEl = calc.querySelector("[data-calc-return]");
		const btnText = calc.querySelector("[data-calc-btn-text]");

		if (!slider) return;

		const min = parseFloat(slider.min) || 0;
		const max = parseFloat(slider.max) || 100;

		const update = () => {
			const value = parseFloat(slider.value) || 0;
			const percent = max > min ? ((value - min) / (max - min)) * 100 : 0;

			slider.style.backgroundSize = `${percent}% 100%`;

			if (amountEl) amountEl.textContent = formatAmount(value);
			if (returnEl) {
				returnEl.textContent = `${formatAmount(value + Math.round(value * 0.001))} ₸`;
			}
			if (btnText) btnText.textContent = `Получить ${formatAmount(value)}`;
		};

		slider.addEventListener("input", update);
		update();
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initCalcTime();
	initCalculator();
});
